export default __webpack_public_path__ + "media/menu_resources/resources-891868ab.png";